// src/components/SelectPaisesEstados.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const PAISES = [
  "México",
  "Estados Unidos",
  "Alemania",
  "Arabia Saudita",
  "Argentina",
  "Australia",
  "Austria",
  "Bélgica",
  "Bolivia",
  "Brasil",
  "Bulgaria",
  "Canadá",
  "Chile",
  "China",
  "Colombia",
  "Corea del Sur",
  "Costa Rica",
  "Croacia",
  "Cuba",
  "Dinamarca",
  "Ecuador",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Eslovaquia",
  "Eslovenia",
  "España",
  "Estonia",
  "Filipinas",
  "Finlandia",
  "Francia",
  "Grecia",
  "Guatemala",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irlanda",
  "Islandia",
  "Israel",
  "Italia",
  "Japón",
  "Kenia",
  "Letonia",
  "Lituania",
  "Luxemburgo",
  "Malasia",
  "Malta",
  "Nicaragua",
  "Nigeria",
  "Noruega",
  "Nueva Zelanda",
  "Países Bajos",
  "Panamá",
  "Paraguay",
  "Perú",
  "Polonia",
  "Portugal",
  "Puerto Rico",
  "Reino Unido",
  "República Checa",
  "República Dominicana", // <- corrige este typo (tenías "Domicana")
  "Rumania",
  "Rusia",
  "Singapur",
  "Sudáfrica",
  "Suecia",
  "Suiza",
  "Tailandia",
  "Turquía",
  "Ucrania",
  "Uruguay",
  "Venezuela",
  "Vietnam",
];

const ESTADOS_MX = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila",
  "Colima",
  "Durango",
  "Estado de México",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatán",
  "Zacatecas",
];

const slugKey = (value) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();

export default function SelectPaisesEstados({ pais, estado, onChange, disabled }) {
  const { t } = useTranslation();
  const estadosDisponibles = pais === "México" ? ESTADOS_MX : [];

  const labelPais = (p) => t(`geo.countries.${slugKey(p)}`, p);

  return (
    <>
      {/* ESTADO */}
      <div className="fiscal-field">
        <label className="fiscal-label">{t("address.state")}</label>
        <select
          className="fiscal-control"
          name="estado"
          value={estado}
          onChange={onChange}
          disabled={disabled || pais !== "México"}
        >
          <option value="">{t("common.select")}</option>
          {estadosDisponibles.map((e) => (
            <option key={e} value={e}>
              {e}
            </option>
          ))}
        </select>
      </div>

      {/* PAÍS */}
      <div className="fiscal-field">
        <label className="fiscal-label">{t("address.country")}</label>
        <select
          className="fiscal-control"
          name="pais"
          value={pais}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="">{t("common.select")}</option>
          {PAISES.map((p) => (
            <option key={p} value={p}>
              {labelPais(p)}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
